{
  "version": 1,
  "asset_id": "50a5abfd-147f-42f0-a869-94da7da3a1c0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/50a5abfd-147f-42f0-a869-94da7da3a1c0/clip-img_2225.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/50a5abfd-147f-42f0-a869-94da7da3a1c0/clip-img_2225.mp4",
  "original_filename": "clip-img_2225.mp4",
  "size": 167629,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:01Z"
}
